export default __webpack_public_path__ + "static/media/Privacy_Policy_rev_3_3_21.ba38a721.pdf";